import { formValueSelector } from 'redux-form';

import { LINEAR_MODEL_FORM } from '../names';

import { getSelectedParameterType } from 'store/dataset';

const selector = formValueSelector(LINEAR_MODEL_FORM);

const makeFieldValueGetter = field =>
  state => selector(state, field);

export const getPrimaryParameter =
  makeFieldValueGetter('primaryParameter');

export const getSecondaryParameter =
  makeFieldValueGetter('secondaryParameter');

export const getAlpha = makeFieldValueGetter('alpha');

export const getLeftCutoff = state => +selector(state, 'leftCutoff');
export const getRightCutoff = state => +selector(state, 'rightCutoff');

export const isPrimaryParameterSelected =
  state => !!getPrimaryParameter(state);

export const isSecondaryParameterSelected =
  state => !!getSecondaryParameter(state);

export const getPrimaryParameterType = state => {
  const parameterName = getPrimaryParameter(state);
  return getSelectedParameterType(state, parameterName);
};

export const isPrimaryParameterNumerical = state =>
  getPrimaryParameterType(state) === 'numerical';
